import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PingGuardService } from './core/guard/ping-guard.service';
import { AuthPingService } from './core/auth/auth-ping.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';

import { GtmService } from './core/gtm/gtm.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { provideNgxMask } from 'ngx-mask';

export function initializeGtm(gtmService: GtmService) {
  return () => gtmService.injectGtmScripts();
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    NgbCarouselModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    OverlayModule,
    MatTableModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  providers: [
    PingGuardService,
    AuthPingService,
    GtmService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGtm,
      deps: [GtmService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideNgxMask()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
